import { Link } from "@tanstack/react-router";
import { blogPosts, categories, blogHref } from "@/lib/data";

export function RecentPostsWidget({ currentSlug }: { currentSlug?: string }) {
  const recent = blogPosts
    .filter((p) => p.slug !== currentSlug)
    .slice(0, 5);

  return (
    <div className="rounded-2xl border border-border bg-card p-6 shadow-card">
      <h3 className="font-display text-lg font-bold">Recent Posts</h3>
      <div className="mt-5 space-y-5">
        {recent.map((p) => {
          const cat = categories.find((c) => c.slug === p.category);
          return (
            <Link
              key={p.slug}
              {...blogHref(p.slug)}
              className="group flex gap-4"
            >
              <div className="h-16 w-16 shrink-0 overflow-hidden rounded-xl">
                <img
                  src={p.image}
                  alt={p.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="flex flex-col justify-center">
                <span className="text-[10px] font-semibold uppercase tracking-wider text-primary">
                  {cat?.name}
                </span>
                <h4 className="line-clamp-2 font-display text-sm font-semibold leading-snug group-hover:text-primary">
                  {p.title}
                </h4>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
